{
  "myData.delete.section.heading": "Delete account",
  "myData.delete.section.description": "You can permanently delete your account and the personal data attached to it. This action cannot be undone.",
  "myData.delete.trigger": "Delete account",
  "myData.delete.title": "Delete account",
  "myData.delete.irreversible": "Deleting your account is permanent and cannot be undone. Your data is erased immediately; there is no cancellation window.",
  "myData.delete.retainedNote": "Records we are legally required to keep are retained without your personal identity.",
  "myData.delete.confirm": "Delete account permanently",
  "myData.delete.cancel": "Cancel",
  "myData.delete.pending": "Deleting…",
  "myData.delete.done": "Your account has been deleted.",
  "myData.delete.doneClose": "Close",
  "myData.delete.unavailable": "Account deletion is not available yet.",
  "myData.delete.error": "Deleting the account failed. Please try again."
}
